import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import 'firebase/compat/auth'

const firebaseConfig = {
  apiKey: "AIzaSyAlUwDbUkpEodUARIqn-Od-95UxbQy9xoY",
  authDomain: "vue-chat-24c72.firebaseapp.com",
  projectId: "vue-chat-24c72",
  storageBucket: "vue-chat-24c72.appspot.com",
  messagingSenderId: "683054266324",
  appId: "1:683054266324:web:ba63c8a26a97093614c841"
};

// initialize firebase
firebase.initializeApp(firebaseConfig)

const projectFirestore = firebase.firestore()
const projectAuth = firebase.auth()

const timestamp = firebase.firestore.FieldValue.serverTimestamp

export{projectFirestore, timestamp, projectAuth}